/// <amd-module name="Reporting/BoardsReportView/BoardsReportSelectorProps" />

export interface BoardsReportSelectorProps {
    projectId: string;
    teamId: string;
    teamName: string;

    /** The invariant category reference Name used to reliably identify a backlog */
    categoryReferenceName: string;

    /** The user facing name of backlog, used for routing  */
    categoryName: string;

    /** Requests a refresh of current state. */
    lastRefresh?: Date;

    /** Signal handler for load completion, used for TTI lifecycle of parent page. */
    onLoadCompleted?: () => void;

    /** Parameters required for telemetry */
    telemetryProps?: {
        parentPageName: string;
        area?: string;
    }
}

export interface BoardsReportCardProps extends BoardsReportSelectorProps {
    onCardClick: (event?: any) => void;
}
